import { useEffect, useState } from "react";
import { Col, Modal } from "react-bootstrap";
import { Box } from "react-bootstrap-icons";
import { getRequestByAuth } from "../../../../../function/helper";

function AgentCollect() {
  const token = localStorage.getItem("token");

  const [collect, setCollect] = useState({
    mustCollected: "",
    partCount: "",
    showModal: false,
  });

  const getData = async () => {
    const response = await getRequestByAuth("/agent/v1/collect");

    if (response && response.status === 200) {
      setCollect(() => ({
        mustCollected: response.result.count,
        partCount: response.result.partCount,
      }));
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (collect.mustCollected > 0) {
      setCollect(cur => ({ ...cur, showModal: true }));
    }
  }, [collect.mustCollected]);

  return (
    <section className="d-flex flex-wrap mt-3">
      <Col>
        <div className="text-start">
          <div className="h4 bg-uncollected-agent" style={{ color: "#E50000" }}>
            <Box size={25} style={{ color: "#482b88" }} className="m-1" />:{" "}
            {collect.mustCollected} سفارش شامل {collect.partCount} بسته در
            انتظار جمع آوری
          </div>
        </div>

        <Modal
          show={collect.showModal}
          direction="rtl"
          centered
          backdrop={"static"}
        >
          <Modal.Header className="">
            <Modal.Title>
              <div>نماینده محترم:</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="d-flex align-items-center justify-content-center text-right "
            style={{ textAlign: "right", direction: "rtl" }}
          >
            <div className="w-100">
              <div className="d-flex flex-wrap">
                <Col className="fw-bold mb-3">
                  <div className="h5 text-danger d-flex align-items-center justify-content-center fw-bold">
                    تعداد {collect.mustCollected} سفارش شامل {collect.partCount}{" "}
                    بسته درانتظار جمع آوری میباشد <br />
                  </div>
                  <div className=" d-flex align-items-center justify-content-center">
                    لطفا نسبت به جمع آوری مرسولات ثبت شده اقدام فرمایید.
                  </div>
                </Col>
              </div>

              <Modal.Footer className="d-flex align-item-center justify-content-center">
                <button
                  className="btn-success-style"
                  onClick={() =>
                    setCollect(cur => ({ ...cur, showModal: false }))
                  }
                >
                  متوجه شدم
                </button>
                <button
                  className="btn-cancel-style"
                  onClick={() => {
                    window.open(
                      `https://agent.avaex.ir/tokenLogin/${token}`,
                      "_blank"
                    );

                    setCollect(cur => ({ ...cur, showModal: false }));
                  }}
                >
                  مشاهده و ارجاع به جمع آور
                </button>
              </Modal.Footer>
            </div>
          </Modal.Body>
        </Modal>
      </Col>
    </section>
  );
}

export default AgentCollect;
